import { render, staticRenderFns } from "./gridUpdatedOn.vue?vue&type=template&id=1b56b4c6&scoped=true&"
import script from "./gridUpdatedOn.vue?vue&type=script&lang=js&"
export * from "./gridUpdatedOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56b4c6",
  null
  
)

export default component.exports